import { isShareCredentials, LiveSessionError } from './share.js';
export const MAX_VOICE_BYTES = 3 * 1024 * 1024;
export const MAX_VOICE_SECONDS = 120;
export const recordingMimeType = (Recorder = globalThis.MediaRecorder) => {
  if (!Recorder?.isTypeSupported) return '';
  return ['audio/webm;codecs=opus', 'audio/mp4', 'audio/webm', 'audio/ogg;codecs=opus']
    .find((type) => Recorder.isTypeSupported(type)) || '';
};
export const formatRecordingTime = (seconds) => `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${Math.floor(seconds % 60).toString().padStart(2, '0')}`;
export const voiceErrorKey = (error) => {
  if (error?.name === 'NotAllowedError' || error?.name === 'SecurityError') return 'voice.permissionDenied';
  if (error?.name === 'NotSupportedError') return 'voice.unsupported';
  if (error?.name === 'NotFoundError' || error?.name === 'NotReadableError') return 'voice.microphoneUnavailable';
  if (['expired', 'revoked', 'invalid', 'session-gone', 'session-ended'].includes(error?.code)) return 'voice.sessionEnded';
  if (error?.code === 'rate-limited' || error?.code === 'upload-pending') return 'voice.tryLater';
  if (error?.code === 'too-large') return 'voice.tooLarge';
  return 'voice.sendFailed';
};
export const blobBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(',')[1]);
  reader.onerror = () => reject(new Error('Unable to read recording.'));
  reader.readAsDataURL(blob);
});
export const sendVoiceRecording = async ({ credentials, messageId, blob, durationSeconds, senderName, signal, fetchImpl = globalThis.fetch }) => {
  if (!isShareCredentials(credentials)) throw new LiveSessionError('invalid', 'Invalid session link.');
  if (!blob?.size || blob.size > MAX_VOICE_BYTES) throw new LiveSessionError('too-large', 'Recording is too large.');
  const audioBase64 = await blobBase64(blob);
  let response;
  try { response = await fetchImpl('/api/live-voice', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, cache: 'no-store', referrerPolicy: 'no-referrer', signal,
    body: JSON.stringify({ ...credentials, messageId, audioBase64, mimeType: blob.type, durationSeconds, senderName })
  }); } catch (error) { throw new LiveSessionError('network', error?.message || 'Upload failed.'); }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok !== true) throw new LiveSessionError(data.error || 'network', data.message || 'Upload failed.', response.status);
  return data;
};
